module.exports = __webpack_public_path__ + "static/media/image007.43f7a9bb.jpg";